import { plainToInstance } from 'class-transformer'

import { GetPoisParams } from '@/api/client/detail/dto/detailDto'
import { GetPoisResDto } from '@/api/dto/poi'
import axios from '@/lib/axiosClient'

/**
 * 지도검색 (핀조회)
 * @params {geocode: string}
 * @result {GetPoisResDto}
 */
async function getParkinglotsByGeoCode(params: GetPoisParams): Promise<GetPoisResDto> {
  const { data } = await axios.get<GetPoisResDto>('/poi/pins', {
    params: {
      geohash: params.geocode,
      shareMode: 'true',
      partnerMode: 'true'
    }
  })

  return plainToInstance(GetPoisResDto, data)
}

const detailApi = {
  getParkinglotsByGeoCode
}

export default detailApi
